var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00267f",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc726",
    d: "M18.1 0H36v40H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M27 11.3q-.7 2.5-2.4 4.5.6-.3 1.5-.3v6.7l-1.9.2v-.2q-.4-3-1.3-5.6c0-.2-.8-1.2-.2-1l.7.2a7 7 0 0 0-3.9-2q-.2 0 0 .1c1.8 3 3.4 6.3 3.3 10.4.8 0 2.5-.5 3.3-.5v4.7h.9l.2-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M27 11.3c.6 1.6 1.1 3.2 2.4 4.5q-.7-.3-1.5-.3v6.7l1.9.2v-.2q.4-3 1.3-5.6c0-.2.7-1.2.2-1l-.7.2a7 7 0 0 1 3.9-2q.2 0 0 .1a19 19 0 0 0-3.4 10.4c-.7 0-2.5-.5-3.2-.5v4.7h-1l-.1-13z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/bb.876bfcde7380c7f120330c20e88b4a53.svg";
export { ForwardRef as ReactComponent };